// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/downloadIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Download" aria-label="Download" />;
}
